import React, { useEffect, useState } from "react";
// import YTVideo from "./YTVideo";



function Sample() {
  const userData = [
    { name: "Jeevan" },
    { name: "Manish" },
    { name: "Prince" },
    { name: "Arti" },
    { name: "rahul" }
  ];
  const [users, setUsers] = useState(userData);
  
  // console.log(users)
  // useEffect(() => {
  //   setUsers(userData);
  // }, []);
  
  // console.log(users)
  const handleChange = (e) => {
const { name, checked } = e.target;
if (name === "allSelect") {
  let tempUser = users.map((user) => {
    // console.log(user)
    return { ...user, isChecked: checked };
  });
  setUsers(tempUser);
} else {
  let tempUser = users.map((user) =>{
    // console.log(user)
    return(
    user.name === name ? { ...user, isChecked: checked } : user
    
)});
  setUsers(tempUser);
  console.log(tempUser)
}
};

return (
<div className="container my-4" style={{ width: "500px" }}>
  <form className="form w-100">
    <h3>Select Users</h3>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        name="allSelect"
        // checked={
        //   users.filter((user) => user?.isChecked !== true).length < 1
        // }
        checked={!users.some((user) => user?.isChecked !== true)}
        onChange={handleChange}
      />
      <label className="form-check-label ms-2">All Select</label>
    </div>
    {users.map((user, index) => (
      <div className="form-check" key={index}>
        <input
          type="checkbox"
          className="form-check-input"
          name={user.name}
          checked={user?.isChecked || false}
          onChange={handleChange}
        />
        <label className="form-check-label ms-2">{user.name}</label>
      </div>
    ))}
  </form>
  </div>
);
}

export default Sample;
